import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { eskPartiApi, tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';

const TIPLER: Record<string, string> = {
  gebe_duve: 'Gebe Düve', bos_duve: 'Boş Düve', besilik: 'Besilik Sığır',
};
const BORCLANMA_TIPLERI: Record<string, string> = {
  karkas_mahsuplasma: 'Karkas Mahsuplaşma', vadeli_satis: 'Vadeli Satış',
};

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

async function getTanimlar(modul: string) {
  const res = await fetch(`${API}/api/tanimlar2/liste?modul=${modul}&sadece_yaprak=true`, { headers: headers() });
  return res.ok ? res.json() : [];
}

const emptyForm = {
  isletme_id: '', parti_no: '', irk_kod: '', tip: 'gebe_duve',
  esk_kombina: '', teslim_tarihi: '', borclanma_tipi: 'karkas_mahsuplasma',
  gelen_hayvan_sayisi: 0, esk_fatura_tutari_tl: '', vadeli_birim_fiyat_tl: '',
  karkas_kg_fiyati: '', durum: 'acik', aciklama: '',
};

export default function EskPartiListesi() {
  const nav = useNavigate();
  const [partiler, setPartiler] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [irklar, setIrklar] = useState<any[]>([]);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState<any>({ ...emptyForm });
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre, setFiltre] = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return { isletme_id: sp.get('isletme') || '', tip: sp.get('tip') || '', yil: sp.get('yil') || '' };
  })());

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isGM = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);

  useEffect(() => {
    if (!isGM && user?.isletme_id) {
      setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
      setForm(f => ({ ...f, isletme_id: user.isletme_id }));
    }
    getTanimlar('buyukbas_irk').then(setIrklar);
    tanimlarApi.isletmelerListesi().then(r => setIsletmeler(r.data));
  }, []);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const params: any = {};
    if (filtre.isletme_id) params.isletme_id = filtre.isletme_id;
    if (filtre.tip) params.tip = filtre.tip;
    if (filtre.yil) params.yil = filtre.yil;
    eskPartiApi.partilerListe(params).then(r => setPartiler(r.data)).catch(() => setPartiler([]));
  };

  const irkAdi = (kod: string) => irklar.find(i => i.kod === kod)?.ad || kod;

  const duzenleAc = (p: any) => {
    setSecili(p);
    setForm({
      isletme_id: p.isletme_id, parti_no: p.parti_no, irk_kod: p.irk_kod || '', tip: p.tip,
      esk_kombina: p.esk_kombina || '', teslim_tarihi: p.teslim_tarihi || '',
      borclanma_tipi: p.borclanma_tipi, gelen_hayvan_sayisi: p.gelen_hayvan_sayisi ?? 0,
      esk_fatura_tutari_tl: p.esk_fatura_tutari_tl ?? '', vadeli_birim_fiyat_tl: p.vadeli_birim_fiyat_tl ?? '',
      karkas_kg_fiyati: p.karkas_kg_fiyati ?? '', durum: p.durum || 'acik', aciklama: p.aciklama || '',
    });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.parti_no) { setHata('Parti no giriniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const body = {
        ...form,
        isletme_id: Number(form.isletme_id),
        gelen_hayvan_sayisi: Number(form.gelen_hayvan_sayisi) || 0,
        esk_fatura_tutari_tl: form.esk_fatura_tutari_tl ? Number(form.esk_fatura_tutari_tl) : null,
        vadeli_birim_fiyat_tl: form.vadeli_birim_fiyat_tl ? Number(form.vadeli_birim_fiyat_tl) : null,
        karkas_kg_fiyati: form.karkas_kg_fiyati ? Number(form.karkas_kg_fiyati) : null,
        teslim_tarihi: form.teslim_tarihi || null,
      };
      if (secili) {
        await eskPartiApi.partiGuncelle(secili.id, body);
      } else {
        await eskPartiApi.partiOlustur(body);
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu partiyi silmek istiyor musunuz? Tüm alt kayıtlar (aylık bakım, çıkış kayıtları vb.) da silinecek.')) return;
    try { await eskPartiApi.partiSil(id); yukle(); } catch (e: any) { alert(e.response?.data?.detail || 'Silinemedi'); }
  };

  const n = (v: any) => (v ?? 0).toLocaleString('tr-TR');

  const columns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (p: any) => p.isletme_ad, filterValue: (p: any) => p.isletme_ad || '' },
    { key: 'parti_no', label: 'Parti No', sortable: true, filterable: true, render: (p: any) => <strong>{p.parti_no}</strong> },
    { key: 'tip', label: 'Tip', sortable: true, filterable: true, render: (p: any) => TIPLER[p.tip] || p.tip, filterValue: (p: any) => TIPLER[p.tip] || p.tip },
    { key: 'borclanma_tipi', label: 'Borçlanma Usulü', sortable: true, filterable: true, render: (p: any) => BORCLANMA_TIPLERI[p.borclanma_tipi] || p.borclanma_tipi },
    { key: 'teslim_tarihi', label: 'Teslim Tarihi', sortable: true, render: (p: any) => p.teslim_tarihi || '-' },
    { key: 'gelen_hayvan_sayisi', label: 'Hayvan Sayısı', sortable: true, render: (p: any) => n(p.gelen_hayvan_sayisi), sortValue: (p: any) => Number(p.gelen_hayvan_sayisi || 0) },
    { key: 'durum', label: 'Durum', sortable: true, filterable: true, render: (p: any) => (
      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: p.durum === 'acik' ? '#eafaf1' : '#f4f4f4', color: p.durum === 'acik' ? '#1e8449' : '#888' }}>
        {p.durum === 'acik' ? 'Açık' : 'Kapalı'}
      </span>
    ) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (p: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        <button className="btn btn-primary btn-sm" onClick={() => nav(`/esk-parti/${p.id}`)}>Detay</button>
        <button className="btn btn-sm" style={{ background: '#f0f4f8', color: '#1a5276' }} onClick={() => duzenleAc(p)}>Düzenle</button>
        <button className="btn btn-danger btn-sm" onClick={() => sil(p.id)}>Sil</button>
      </div>
    ) },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>🐂 ESK-TİGEM Parti Listesi</h1>
        <p>Damızlık düve / besilik sığır partilerinin maliyet-kâr/zarar takibi</p>
      </div>

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: e.target.value })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 170 }} value={filtre.tip}
              onChange={e => setFiltre({ ...filtre, tip: e.target.value })}>
              <option value="">Tüm Tipler</option>
              {Object.entries(TIPLER).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
            {isGM && (
              <select className="search-input" style={{ width: 200 }} value={filtre.isletme_id}
                onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                <option value="">Tüm İşletmeler</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            )}
          </div>
          <button className="btn btn-success" onClick={() => { setSecili(null); setForm({ ...emptyForm, isletme_id: filtre.isletme_id || (isGM ? '' : user?.isletme_id) }); setHata(''); setModalAcik(true); }}>+ Yeni Parti</button>
        </div>

        <DataTable columns={columns} data={partiler} rowKey={(p: any) => p.id} exportFilename="esk-parti-listesi" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => { setModalAcik(false); setSecili(null); }}>
          <div className="modal" style={{ width: 620 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🐂 {secili ? `Parti Düzenle — ${secili.parti_no}` : 'Yeni Parti'}</h3>
              <button className="modal-close" onClick={() => { setModalAcik(false); setSecili(null); }}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              <div className="form-row">
                {isGM && (
                  <div className="form-group">
                    <label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id}
                      onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Parti No *</label>
                  <input className="form-control" value={form.parti_no}
                    onChange={e => setForm({ ...form, parti_no: e.target.value })} placeholder="Örn: 1. Parti" />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Tip *</label>
                  <select className="form-control" value={form.tip} onChange={e => setForm({ ...form, tip: e.target.value })}>
                    {Object.entries(TIPLER).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Irk <small style={{color:'#999', fontWeight:'normal'}}>({irklar.length} tanım yüklendi)</small></label>
                  <select className="form-control" value={form.irk_kod} onChange={e => setForm({ ...form, irk_kod: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {irklar.map(irk => <option key={irk.kod} value={irk.kod}>{irk.ad} ({irk.kod})</option>)}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>ESK Kombina</label>
                  <input className="form-control" value={form.esk_kombina} onChange={e => setForm({ ...form, esk_kombina: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Teslim Tarihi</label>
                  <input className="form-control" type="date" value={form.teslim_tarihi} onChange={e => setForm({ ...form, teslim_tarihi: e.target.value })} />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Borçlanma Usulü *</label>
                  <select className="form-control" value={form.borclanma_tipi} onChange={e => setForm({ ...form, borclanma_tipi: e.target.value })}>
                    {Object.entries(BORCLANMA_TIPLERI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Gelen Hayvan Sayısı *</label>
                  <input className="form-control" type="number" value={form.gelen_hayvan_sayisi} onChange={e => setForm({ ...form, gelen_hayvan_sayisi: e.target.value })} />
                </div>
              </div>

              <div className="form-row">
                {form.borclanma_tipi === 'karkas_mahsuplasma' ? (
                  <div className="form-group">
                    <label>ESK Fatura Tutarı (TL)</label>
                    <input className="form-control" type="number" value={form.esk_fatura_tutari_tl} onChange={e => setForm({ ...form, esk_fatura_tutari_tl: e.target.value })} />
                  </div>
                ) : (
                  <div className="form-group">
                    <label>Vadeli Birim Fiyat (TL/baş)</label>
                    <input className="form-control" type="number" value={form.vadeli_birim_fiyat_tl} onChange={e => setForm({ ...form, vadeli_birim_fiyat_tl: e.target.value })} />
                  </div>
                )}
                <div className="form-group">
                  <label>Karkas Kg Fiyatı (HAYGEM)</label>
                  <input className="form-control" type="number" value={form.karkas_kg_fiyati} onChange={e => setForm({ ...form, karkas_kg_fiyati: e.target.value })} />
                </div>
              </div>

              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => { setModalAcik(false); setSecili(null); }} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
